import React, {useEffect, useState} from "react";
import { ReactComponent as SortGrey } from "../images/SortingIcon.svg";
import { ReactComponent as SortDown } from "../images/SortingIconDesc.svg";
import { ReactComponent as SortUp } from "../images/SortingIconAsec.svg";
import classes from "./TableSortHeader.module.css"
import {BUTTON} from "../utils/constants";
import {Button} from "@base-ui/react/button";

export default function TableSortHeaderNew({
                                               propertyName, getProperty,
                                               data, setData,
                                               sortedBy, setSortedBy,
                                               label,
                                               as: Component = "th",
                                               children,
                                               ...props
}) {

    const {key, ...rest} = props;

    // ascending: 1, descending: -1
    const [sortStatus, setSortStatus] = useState(1);
    const [ariaSort, setAriaSort] = useState("none");

    const nameSortHelper = (e) => {
        e.stopPropagation();
        if(!!data) {
            let copy = JSON.parse(JSON.stringify(data)).sort(function (a, b) {
                let nameA = "";
                let nameB = "";
                if (!!getProperty) {
                    nameA = getProperty(a);
                    nameB = getProperty(b);
                } else {
                    nameA = a.hasOwnProperty(propertyName) ? a[propertyName].toString().toLowerCase() : "";
                    nameB = b.hasOwnProperty(propertyName) ? b[propertyName].toString().toLowerCase() : "";
                }


                return nameA.localeCompare(nameB, undefined, { numeric: true }) * sortStatus;

                // let res = nameA.localeCompare(nameB);
                // if (res === 1) {
                //     return -1 * sortStatus;
                // } else if (res === -1) {
                //     return sortStatus;
                // } else {
                //     return 0;
                // }
            });
            setData(copy);
        }

        setSortStatus(-1 * sortStatus)
        setSortedBy(propertyName);
    }

    useEffect(() => {
        if (sortedBy === propertyName) {
            if (sortStatus === 1) {
                setAriaSort("ascending");
            } else {
                setAriaSort("descending");
            }
        } else {
            setAriaSort("none");
        }

    }, [propertyName, sortedBy, sortStatus]);

    return (
        <Component
            className={classes.sortableHeader}
            aria-sort={ariaSort}
            onClick={nameSortHelper}
            {...rest}
        >
            <Button className={classes.parentContainer} >
                {children}
                <span className={classes.sortUnit}>
                    {sortedBy === propertyName && sortStatus === 1 && <SortUp/>}
                    {sortedBy === propertyName && sortStatus === -1 && <SortDown/>}
                    {sortedBy !== propertyName && <SortGrey/>}
                </span>
            </Button>
        </Component>

    );
}